import vClickOutside from 'v-click-outside';
import {mapActions, mapState, mapGetters} from 'vuex';
import {SERVICE_TYPE_CODE, MAIN_SERVICE_TYPES, CART_ITEM_TYPE} from '../../common/constants/constants';

import eventBus from '../../common/event-bus/event-bus';

const MAIN_TYPE_NAME = {
	[SERVICE_TYPE_CODE.FIX_NET]: 'INTERNET',
	[SERVICE_TYPE_CODE.TELEFON_MGCP]: 'TELEFON',
	[SERVICE_TYPE_CODE.ANALOG_TV]: 'KÁBELTV'
};

export default {
	directives: {
		clickOutside: vClickOutside.directive
	},
	computed: {
		...mapGetters('cartsStore', ['activeAddress']),
		...mapState('warningModalStore', ['inCartItems', 'addedItem']),

		displayedAddress() {
			return `${this.activeAddress.telepulesNev}, ${this.activeAddress.irsz}, ${this.activeAddress.utca}, ${this.activeAddress.hazSzam}`;
		},

		inCartItemsMainServices() {
			return this.inCartItems.map(webitem => webitem.items).flat(1).filter(item => MAIN_SERVICE_TYPES.includes(item.szolgaltatasJellegKod));
		},

		addedItemMainServices() {
			return this.addedItem.items.filter(item => MAIN_SERVICE_TYPES.includes(item.szolgaltatasJellegKod));
		},

		inCartItemsConflictingServices() {
			return this.inCartItemsMainServices.reduce((conflictingServices, currentService) => {
				if (this.addedItemMainServices.find(item => item.szolgaltatasJellegKod == currentService.szolgaltatasJellegKod)) {
					conflictingServices.push(currentService);
				}
				return conflictingServices;
			}, []);
		},

		addedItemConflictingServices() {
			return this.addedItemMainServices.reduce((conflictingServices, currentService) => {
				if (this.inCartItemsMainServices.find(item => item.szolgaltatasJellegKod == currentService.szolgaltatasJellegKod)) {
					conflictingServices.push(currentService);
				}
				return conflictingServices;
			}, []);
		},

		conflictingServiceTypes() {
			let conflictingServiceTypes = [];

			// collect main types
			conflictingServiceTypes = this.inCartItemsMainServices.map(item => item.szolgaltatasJellegKod);
			conflictingServiceTypes = [
				...conflictingServiceTypes,
				...this.addedItemMainServices.map(item => item.szolgaltatasJellegKod)
			];

			// keep only duplicated -> conflicting
			conflictingServiceTypes = conflictingServiceTypes
				.filter((type, index, types) => types.indexOf(type) == index && types.lastIndexOf(type) !== index);

			// map to displayed names
			conflictingServiceTypes = conflictingServiceTypes
				.map(type => MAIN_TYPE_NAME[type]);

			return conflictingServiceTypes;
		},

		CART_ITEM_TYPE() {
			return CART_ITEM_TYPE;
		}
	},
	methods: {
		...mapActions('cartsStore', ['forceAddToCart']),

		toggle() {
			eventBus.$emit('close-conflictingItemsInCartPopup');
		},

		async changePackages() {
			this.forceAddToCart({
				addId: this.addedItem.id,
				removeIds: this.inCartItems.map(item => item.id)
			});
			this.toggle();
		},

		onlyMainServices(list) {
			return list.filter(item => MAIN_SERVICE_TYPES.includes(item.szolgaltatasJellegKod));
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL07-warning/MDL07-warning.js